import React, {useContext, useEffect, useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid} from '@mui/material';
import {Field, Form, Formik} from 'formik';
import {TextField} from 'formik-mui';
import {Zoom} from '@mui/material';
import Box from '@mui/material/Box';
import {Autocomplete} from '@mui/material';
import {rolesAPi, usersActionServices} from '../../../services/UserServices';
import {museumApi} from '../../../services/MuseumServices';
import {SNACKBAR_OPEN} from '../../../reducers';
import {DispatchContext, StateContext} from '../../../store';
import {invitationServices} from '../../../services/AuthServices';
import {userInitialValue, userValidation} from './UserModel';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom style={{transitionDelay: '150ms'}} ref={ref} {...props}/>;
});

export default function InviteUsers({open, handleAction, userId, editProfile}) {
  const dispatch = useContext(DispatchContext);
  const {role} = useContext(StateContext);
  const [initialValues, setInitialValues] = useState(userInitialValue);
  const [roles, setRoles] = useState([]);
  const [museums, setMuseums] = useState([]);
  const user = JSON.parse(localStorage.getItem('user'));

  const isAdminOrChief = role?.id === 1 || role?.id === 10;

  const filteredRoleOptions = isAdminOrChief
    ? roles.filter((option) => Number(option?.id) === 10)
    : roles.filter((option) => !['Super Admin', 'BIRMS payment user', 'Curator', 'General user'].includes(option.description));

  useEffect(() => {
    if (open && userId) {
      usersActionServices('get', userId).then(res => {
        const roleArray = Object.values(res?.data?.roles || {}).map(role => role?.id);
        setInitialValues({
          ...res?.data,
          role_ids: roleArray,
        });
      });
    }
  },[open]);

  useEffect(() => {
    getRoleList();
    museumApi('get').then((res) => {
      setMuseums(res?.data || []);
    });
  }, []);

  const getRoleList = () => {
    rolesAPi('get').then(res => {
      setRoles(res?.data);
    })
  }

  const onSubmit = (values, {setSubmitting, resetForm}) => {
    const isAdminOrChiefInvitingRole10 = isAdminOrChief && Number(values?.role_ids) === 10;
    let userValues = {
      ...values,
      museum_ids: isAdminOrChiefInvitingRole10 ? (values?.museum_ids || []) : [user?.museums?.[0]?.id],
      phone: parseInt(values?.phone),
      // cid: parseInt(values?.cid),
      role_ids: [values?.role_ids]
    }

    if (values?.cid) {
      userValues.cid = parseInt(values.cid);
    } else {
      delete userValues.cid;
    }

    const userUpdatedData = {
      ...(isAdminOrChief ? {} : { museum_ids: [user?.museums?.[0]?.id] }),
      first_name: values?.first_name,
      last_name: values?.last_name,
      email:values?.email,
      emp_id: values?.emp_id,
      phone: parseInt(values?.phone),
      cid: parseInt(values?.cid),
      profile: {
        agency: values?.profile?.agency,
      },
      role_ids: values?.role_ids
    }

    if (userId && editProfile) {
      usersActionServices('put', userId, null, {...userUpdatedData}).then(res => {
        let storedData = JSON.parse(localStorage.getItem('user'));
        dispatch({
          type: SNACKBAR_OPEN,
          payload: {isNotify: true, severity: 'success', message: 'User updated successfully'}
        });
        storedData.first_name = res?.data?.first_name;
        storedData.last_name = res?.data?.last_name;
        localStorage.setItem('user', JSON.stringify(storedData));
        dispatch({type: 'STATE', payload: {change: true}});
        handleAction();
        resetForm();
      }).catch((err) => console.error('update user failed', err))
    } else if (userId && !editProfile) {
      usersActionServices('put', userId, null, {...userUpdatedData}).then(res => {
        dispatch({
          type: SNACKBAR_OPEN,
          payload: {isNotify: true, severity: 'success', message: 'User updated successfully'}
        });
        dispatch({type: 'STATE', payload: {change: true}});
        handleAction();
        resetForm();
      }).catch((err) => console.error('update user failed', err))
    } else {
      invitationServices('post', {...userValues}).then(res => {
        dispatch({
          type: SNACKBAR_OPEN,
          payload: {isNotify: true, severity: 'success', message: 'User invited successfully'}
        });
        handleAction();
        resetForm();
      }).catch((err) => console.error('invite user failed', err))
    }
    setSubmitting(false);
  }

  const getSelectedRole = (roleId) => {
    return roles?.find(val => parseInt(val?.id) === parseInt(roleId)) || null;
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleAction}
      aria-describedby="alert-dialog-slide-description"
      fullWidth={true}
      maxWidth={'sm'}
    >
      {!editProfile ?
      <DialogTitle color={'#616B88'} sx={{fontSize: 30}} className={'text-bold'}
                   fontWeight={700}>{userId ? 'Update Museum Staff' : 'Invite Museum Staff'}</DialogTitle>:
      <DialogTitle color={'#616B88'} sx={{fontSize: 30}} className={'text-bold'}
                   fontWeight={700}>Edit Profile</DialogTitle>}
      <Box className={'common-divider'}/>
      <Formik initialValues={initialValues}
              onSubmit={onSubmit} validationSchema={userValidation}
              validateOnBlur={true} enableReinitialize
      >
        {({isSubmitting, touched, errors, values, setFieldValue, ...formik}) => (
          <Form>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item sm={6}>
                  <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
                         label={
                           <div>
                             <span style={{color: 'red'}}>*</span>
                             Name
                           </div>
                         }
                         name="first_name"
                         InputLabelProps={{
                           style: {fontSize: 14, color: '#929191'}
                         }}/>
                </Grid>
                <Grid item sm={6}>
                  <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Surname'}
                         name="last_name"
                         InputLabelProps={{
                           style: {fontSize: 14, color: '#929191'}
                         }}/>
                </Grid>
                <Grid item sm={6}>
                  <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'CID/Passport'}
                         name="cid"
                         inputProps={{ maxLength: 11 }}
                         InputLabelProps={{
                           style: {fontSize: 14, color: '#929191'}
                         }}/>
                </Grid>
                <Grid item sm={6}>
                  <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Employee ID'}
                         name="emp_id"
                         InputLabelProps={{
                           style: {fontSize: 14, color: '#929191'}
                         }}/>
                </Grid>
                <Grid item sm={6}>
                  <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
                         label={
                           <div>
                             <span style={{color: 'red'}}>*</span>
                             Contact No.
                           </div>
                         }
                         name="phone"
                         InputLabelProps={{
                           style: {fontSize: 14, color: '#929191'}
                         }}/>
                </Grid>
                <Grid item sm={6}>
                  <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
                         label={
                           <div>
                             <span style={{color: 'red'}}>*</span>
                             Email ID
                           </div>
                         }
                         name="email" type={'email'} disabled={!!userId}
                         InputLabelProps={{
                           style: {fontSize: 14, color: '#929191'}
                         }}/>
                </Grid>
                <Grid item sm={6}>
                  <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Agency'}
                         name="profile.agency"
                         InputLabelProps={{
                           style: {fontSize: 14, color: '#929191'}
                         }}/>
                </Grid>
                {!editProfile && (
                <Grid item sm={6}>
                  <Autocomplete
                    id="combo-box-demo"
                    options={filteredRoleOptions}
                    value={getSelectedRole(values?.role_ids)}
                    getOptionLabel={(option) => option?.description || ''}
                    size={'small'}
                    fullWidth // Ensure base component spreads out fully inside the cell frame
                    disabled={!!userId}
                    onChange={(e, value) => {
                      setFieldValue('role_ids', value?.id || null);
                    }}
                    renderInput={(params) => (
                      <Field 
                        component={TextField} 
                        {...params}
                        placeholder="Select Role"
                        label={
                          <div>
                            <span style={{color: 'red'}}>*</span>
                            Select Role
                          </div>
                        }
                        InputLabelProps={{style: {color: '#929191', fontSize: 14}}}
                        name="role_ids"
                      />
                    )}
                  />
                </Grid>
              )}

              {!editProfile && isAdminOrChief && Number(values?.role_ids) === 10 && (
                <Grid item sm={6}>
                  <Autocomplete
                    multiple
                    id="museum-ids"
                    options={museums}
                    value={museums.filter((m) => (values?.museum_ids || []).includes(m?.id))}
                    getOptionLabel={(option) => option?.name || ''}
                    isOptionEqualToValue={(o, v) => String(o?.id) === String(v?.id)}
                    size={'small'}
                    fullWidth
                    onChange={(e, next) => {
                      setFieldValue('museum_ids', (next || []).map((x) => x.id));
                    }}
                    renderInput={(params) => (
                      <Field
                        component={TextField}
                        {...params}
                        placeholder="Select Museum"
                        label={
                          <div>
                            <span style={{color: 'red'}}>*</span>
                            Select Museum
                          </div>
                        }
                        InputLabelProps={{style: {color: '#929191', fontSize: 14}}}
                        name="museum_ids"
                      />
                    )}
                


                    />
                  </Grid>
                )}

                
              </Grid>
            </DialogContent>
            <DialogActions >
              <Button onClick={handleAction} variant={'outlined'} color={'error'} className={'text-capitalize'}
                      sx={{width: 40, height: 30}}>cancel</Button>
              <Button variant={'contained'} type={'submit'} className={'text-capitalize'}
                      sx={{width: 40, height: 30}}>{userId ? 'Update' : 'Invite'}</Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};